var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.userAgent, {oled: _vm.AODmode}, {isPWA: _vm.isPWA}],attrs:{"id":"app"}},[_c('Home',{style:({transform: 'translate('+ _vm.offset.x +'px, '+ _vm.offset.y +'px)'})})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }